import { ofType } from "redux-observable";
import { EMPTY, interval } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { IdServerPing } from "../../constants/IdServerPing";
import { CommandCode } from "../../utils/network/generated/protoTypes";
import { TypeActionApp } from "../app/actionApp";
export var epicPing = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), take(1), switchMap(function () {
        return interval(IdServerPing.Game).pipe(switchMap(function () {
            return deps.netSend({
                id: CommandCode.Ping,
                props: {},
            });
        }), switchMap(function () { return EMPTY; }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/network/epicPing.ts
// module id = 2006
// module chunks = 3